import type { CourierTaskListParams } from '../model/types';

export const COURIER_TASK_KEYS = {
  all: ['courier-task'] as const,
  list: (params?: CourierTaskListParams) => [...COURIER_TASK_KEYS.all, 'list', params] as const,
  detail: (id: number, type: number) => [...COURIER_TASK_KEYS.all, 'detail', id, type] as const,
};
